// Lido Smart Search v1779226737 — IT+EN only (no Chinese)
(function(){
  'use strict';

  // ============ SYNONYM MAP ============
  // Bidirectional: if user types A, also search B. Both directions handled.
  const SYN_GROUPS = [
    ['bomboniera','bomboniere','bombo','confettata'],
    ['palloncino','palloncini','balloon','mongolfiera'],
    ['matrimonio','wedding','sposi','sposa','nozze'],
    ['battesimo','baptism','baby','battesimi'],
    ['comunione','comunioni','prima comunione'],
    ['cresima','cresime','confirmation'],
    ['laurea','lauree','graduation'],
    ['compleanno','compleanni','birthday','bday'],
    ['natale','christmas','xmas','natalizio'],
    ['pasqua','easter','pasquetta'],
    ['halloween','horror','spaventoso'],
    ['carnevale','carnival','maschera','maschere','costume'],
    ['giocattoli','giochi','toys','giocattolo'],
    ['cucina','kitchen','cucinare','culinario'],
    ['giardinaggio','giardino','orto','outdoor','garden'],
    ['cancelleria','ufficio','office','scuola','school'],
    ['scotch','nastro adesivo','tape','adesivo','nastri'],
    ['forbice','forbici','taglio','scissors'],
    ['penna','penne','biro','stilografica','pen'],
    ['pennarelli','marker','markers','marcatori','marcatore'],
    ['matita','matite','pencil','pencils'],
    ['gomma','gomme','eraser'],
    ['quaderno','quaderni','notebook','blocchi','blocco'],
    ['zaino','zaini','backpack','schoolbag'],
    ['astuccio','astucci','pencil case'],
    ['tovagliolo','tovaglioli','tovagliolini','napkin','napkins'],
    ['piatto','piatti','plate','plates'],
    ['bicchiere','bicchieri','glass','glasses','calice','calici'],
    ['posata','posate','cutlery','forchetta','forchette','cucchiaio','cucchiai','coltello','coltelli'],
    ['decorazione','decorazioni','deco','decoro','decori'],
    ['fiore','fiori','flower','flowers','rose','rosa'],
    ['cuore','cuori','heart','hearts'],
    ['stella','stelle','star','stars','stelline'],
    ['nastro','nastri','ribbon','ribbons'],
    ['filo','fili','spago','cordoncino','cordini','string','thread'],
    ['glitter','brillantini','diamantini','strass','sparkle'],
    ['carta','cartoncino','paper','cardstock'],
    ['busta','buste','envelope','envelopes','sacchetto','sacchetti'],
    ['scatola','scatole','box','boxes'],
    ['cesto','cesti','cestino','cestini','basket'],
    ['portachiavi','keychain','keyring'],
    ['orsetto','orsetti','peluche','bear','plush'],
    ['lampada','lampade','luce','luci','lamp','lampadina'],
    ['candela','candele','candle','candles','candelina','candeline'],
    ['profumo','profumi','profumatore','profumatori','perfume','fragranza'],
    ['detersivo','detersivi','pulizia','cleaning','detergente'],
    ['spugna','spugne','sponge','sponges'],
    ['guanto','guanti','gloves'],
    ['secchio','secchi','bucket','buckets'],
    ['mocio','mop','panno','panni'],
    ['contenitore','contenitori','container','containers'],
    ['organizer','organizzatore','organizzatori','organiser'],
    ['scaffale','scaffali','shelf','shelves','mensola','mensole'],
    ['gruccia','grucce','hanger','hangers','appendiabiti'],
    ['vaso','vasi','vase','vases','portavasi'],
    ['terriccio','terra','soil','compost'],
    ['concime','concimi','fertilizer','fertilizzante'],
    ['acqua','water','irrigazione','watering','annaffiare'],
    ['tubo','tubi','hose','hoses','manichetta'],
    ['repellente','repellenti','antizanzare','antimosche','insetticida'],
    ['parasole','ombrellone','ombrelloni','umbrella'],
    ['estate','summer','spiaggia','beach','mare','sea'],
    ['piscina','pool','piscine','swimming'],
    ['gonfiabile','gonfiabili','inflatable'],
    ['barbecue','bbq','grill','grigliata'],
    ['lavoro','tool','tools','utensile','utensili'],
    ['trapano','trapani','drill','drills'],
    ['batteria','batterie','battery','batteries','pile','pila'],
    ['cavo','cavi','cable','cables'],
    ['caricabatterie','charger','caricabatteria'],
    ['borsa','borse','bag','bags','sacca','sacche'],
    ['valigia','valige','valigie','suitcase','trolley'],
    ['ombrello','ombrelli','umbrella'],
    ['frigo','frigorifero','fridge','refrigerator'],
    ['microonde','microwave'],
    ['caffettiera','moka','espresso','coffee maker'],
    ['pentola','pentole','pot','pots','padella','padelle','pan','pans'],
    ['coperchio','coperchi','lid','lids']
  ];

  // Build lookup: word → list of synonyms (excluding itself)
  const SYN_MAP = {};
  SYN_GROUPS.forEach(group => {
    group.forEach(w => {
      const key = w.toLowerCase().trim();
      SYN_MAP[key] = group.filter(x => x.toLowerCase().trim() !== key);
    });
  });

  // ============ SYNONYM QUERY EXPANSION ============
  // Called on every search form submit. Rewrites q= to include synonyms via OR.
  function expandQuery(q) {
    if (!q || q.length < 2) return q;
    const cleaned = q.toLowerCase().trim();
    // Tokenize on whitespace
    const tokens = cleaned.split(/\s+/);
    const expandedTokens = [];
    for (const t of tokens) {
      const syns = SYN_MAP[t];
      if (syns && syns.length > 0) {
        // Original token + synonyms wrapped in parens
        expandedTokens.push('(' + [t].concat(syns).join(' OR ') + ')');
      } else {
        expandedTokens.push(t);
      }
    }
    const expanded = expandedTokens.join(' ');
    return expanded !== cleaned ? expanded : q;
  }



  // ============ SEARCH REDIRECTS ============
  // When user submits these queries, navigate directly to the corresponding collection
  const REDIRECTS = {
    // Bomboniere occasioni
    'matrimonio':'/collections/cat-bomb-matrimonio',
    'sposi':'/collections/cat-bomb-matrimonio',
    'sposa':'/collections/cat-bomb-matrimonio',
    'wedding':'/collections/cat-bomb-matrimonio',
    'nozze':'/collections/cat-bomb-matrimonio',
    'battesimo':'/collections/cat-bomb-battesimo',
    'battesimi':'/collections/cat-bomb-battesimo',
    'baby':'/collections/cat-bomb-nascita',
    'nascita':'/collections/cat-bomb-nascita',
    'comunione':'/collections/cat-bomb-comunione',
    'cresima':'/collections/cat-bomb-comunione',
    'laurea':'/collections/cat-bomb-laurea',
    'graduation':'/collections/cat-bomb-laurea',
    'bomboniera':'/collections/cat-bomb',
    'bomboniere':'/collections/cat-bomb',
    'compleanno':'/collections/cat-bomb-compleanno',
    'birthday':'/collections/cat-bomb-compleanno',

    // Stagionali
    'natale':'/collections/cat-natale',
    'christmas':'/collections/cat-natale',
    'xmas':'/collections/cat-natale',
    'pasqua':'/collections/feste-pasqua',
    'easter':'/collections/feste-pasqua',
    'halloween':'/collections/feste-halloween',
    'carnevale':'/collections/feste-carnevale',
    'carnival':'/collections/feste-carnevale',

    // Palloncini
    'palloncini':'/collections/feste-palloncini-colorati',
    'palloncini numeri':'/collections/feste-set-palloncini-numeri',
    'palloncini mylar':'/collections/feste-palloncini-mylar-colorati',
    'candeline':'/collections/feste-candeline-party',
    'decorazioni torta':'/collections/feste-decorazioni-torta',

    // Categorie principali
    'cucina':'/collections/sun-cucina',
    'kitchen':'/collections/sun-cucina',
    'giardinaggio':'/collections/giardino',
    'giardino':'/collections/giardino',
    'garden':'/collections/giardino',
    'cancelleria':'/collections/cat-cancelleria',
    'scuola':'/collections/cat-cancelleria',
    'school':'/collections/cat-cancelleria',
    'happy set':'/collections/happy-set-happy-set',
    'plastica':'/collections/plastica',
    'casalinghi':'/collections/cat-casalinghi',
    'fitness':'/collections/fitness-accessori-allenamento',
    'viaggio':'/collections/viaggio-borse-da-viaggio',
    'viaggiare':'/collections/viaggio-borse-da-viaggio',

    // Sub-bomb
    'sacchetti bomboniere':'/collections/cat-bomb-sacchetti',
    'veli':'/collections/cat-bomb-veli-coni',
    'coni':'/collections/cat-bomb-veli-coni',
    'portaconfetti':'/collections/cancelleria-portaconfetti-matrimonio',

    // Brand
    'hd star':'/collections/hd-star-cucina',
    'sunlux':'/collections/sun-cucina'
  };

  function checkRedirect(q) {
    const key = q.toLowerCase().trim();
    return REDIRECTS[key] || null;
  }

  // Intercept predictive-search AJAX (suggest/predict requests) to expand synonyms
  const _origFetch = window.fetch;
  window.fetch = function(input, init) {
    try {
      let url = typeof input === 'string' ? input : (input && input.url);
      if (url && (url.includes('/search/suggest') || url.includes('/search/predict'))) {
        const m = url.match(/[?&]q=([^&]+)/);
        if (m) {
          const orig = decodeURIComponent(m[1]);
          const expanded = expandQuery(orig);
          if (expanded !== orig) {
            url = url.replace(/([?&])q=[^&]+/, '$1q=' + encodeURIComponent(expanded));
            if (typeof input === 'string') {
              input = url;
            } else {
              input = new Request(url, input);
            }
          }
        }
      }
    } catch(e) { /* silent */ }
    return _origFetch.call(this, input, init);
  };

  // Intercept all search forms on submit
  function installSearchInterceptor() {
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (!form || form.getAttribute('action') !== '/search') return;
      const input = form.querySelector('input[name="q"]');
      if (!input || !input.value.trim()) return;
      // 1. Check redirects first — if match, navigate to collection
      const redirect = checkRedirect(input.value);
      if (redirect) {
        e.preventDefault();
        window.location.assign(redirect);
        return;
      }
      // 2. Expand synonyms — but submit via URL navigation so we control both q (expanded) and qd (display)
      const original = input.value;
      const expanded = expandQuery(original);
      if (expanded !== original) {
        e.preventDefault();
        const url = '/search?q=' + encodeURIComponent(expanded) + '&qd=' + encodeURIComponent(original);
        window.location.assign(url);
      }
    }, true);
  }

  // ============ DISPLAY CLEANUP (robust) ============
  // Hide expanded query from URL and visible input fields
  function getCleanDisplay() {
    const params = new URLSearchParams(window.location.search);
    const qd = params.get('qd');
    const q = params.get('q');
    if (qd) return qd;
    if (q && q.startsWith('(') && q.includes(' OR ')) {
      // Extract first term from expanded query
      const m = q.match(/^\(([^\s)]+)/);
      return m ? m[1] : q;
    }
    return null;
  }
  function applyCleanDisplay() {
    const display = getCleanDisplay();
    if (!display) return;
    document.querySelectorAll('input[name="q"]').forEach(inp => {
      if (inp.value !== display) inp.value = display;
    });
  }
  // Also clean the visible URL (remove qd param + replace expanded q with original)
  function cleanUrl() {
    const display = getCleanDisplay();
    if (!display) return;
    const url = new URL(window.location.href);
    if (url.searchParams.get('q') !== display || url.searchParams.has('qd')) {
      url.searchParams.set('q', display);
      url.searchParams.delete('qd');
      try { history.replaceState({}, '', url.toString()); } catch(e){}
    }
  }
  function runCleanup() {
    applyCleanDisplay();
    cleanUrl();
  }
  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runCleanup);
  } else {
    runCleanup();
  }
  // Run again on full load (after theme JS)
  window.addEventListener('load', runCleanup);
  // Periodic safety: re-apply for 3 seconds after load (catches lazy modal inputs)
  let cleanupCount = 0;
  const cleanupInterval = setInterval(() => {
    applyCleanDisplay();
    cleanupCount++;
    if (cleanupCount > 30) clearInterval(cleanupInterval);
  }, 100);
  // MutationObserver: fix any new input[name="q"] added dynamically
  if (window.MutationObserver) {
    new MutationObserver(applyCleanDisplay).observe(document.body || document.documentElement, {
      childList: true, subtree: true
    });
  }

  // ============ INIT ============
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      installSearchInterceptor();
});
  } else {
    installSearchInterceptor();
}
})();
